import { render, staticRenderFns } from "./IconCardCracked.vue?vue&type=template&id=3923620c&scoped=true&"
var script = {}
import style0 from "./IconCardCracked.vue?vue&type=style&index=0&id=3923620c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3923620c",
  null
  
)

export default component.exports